import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FakeText, Typography } from '@totalsoft/rocket-ui';
import { Tooltip, IconButton, Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material';
import { Delete} from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getErrors } from '@totalsoft/pure-validations-react';
import ScoringCategoryDetailItemComponent from './ScoringCategoryDetailItemComponent';
import ScoringCategoryDetailItemSummary from './ScoringCategoryDetailItemSummary';

const ScoringCategoryDetailListComponent = ({
  scoringCategoryDetails,
  loading,
  dispatch,
  scaleFormat,
  onDelete,
  visibleNumeric,
  validation
}) => {
  const { t } = useTranslation();
  const onExpandChange = (isExpanded, index) => {
    dispatch({ type: 'OnDetailExpanded', index, isExpanded });
  };

  const onDeleteDetail = (scoringCategoryDetail, index) => {
    if (window.confirm(t('ScoringCategories.DeleteDetail'))) {
      if (scoringCategoryDetail.scoringDetailId !== null) {
        onDelete(scoringCategoryDetail.scoringDetailId, index);
      } else {
        dispatch({ type: 'OnDetailDelete', index });
      }
    }
  };

  return scoringCategoryDetails.map((item, idx) => {
    const header = (
      <ScoringCategoryDetailItemSummary scoringCategoryDetails={item} visibleNumeric={visibleNumeric} scaleFormat={scaleFormat} />
    );

    return (
      <Grid key={idx} item xs={12} sx={{ marginBottom: '35px!important' }}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandChange(isExpanded, idx)}>
          <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <Fragment>
                <Typography variant='h6'> {item.name}</Typography>
                <Grid item xs={12} sm={12} onClick={event => event.stopPropagation()}>
                  <Grid container spacing={1} justifyContent='flex-end'>
                    <Grid item>
                      <Tooltip title={t('Tooltips.ScoringCategories.DeleteDetail')}>
                        <IconButton color='primary' onClick={() => onDeleteDetail(item, idx)}>
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </Fragment>
            )}
            {!item.isExpanded && <div style={{ width: '100%' }}>{header}</div>}
          </AccordionSummary>
          <AccordionDetails>
            {loading ? (
              <FakeText lines={10} />
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography color='error'>{validation |> getErrors}</Typography>
                </Grid>
                <ScoringCategoryDetailItemComponent
                  scoringCategoryDetail={item}
                  index={idx}
                  dispatch={dispatch}
                  loading={loading}
                  scaleFormat={scaleFormat}
                  onDelete={onDelete}
                  visibleNumeric={visibleNumeric}
                  validation={validation[idx]}
                />
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

ScoringCategoryDetailListComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  scoringCategoryDetails: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  visibleNumeric: PropTypes.number,
  scaleFormat: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default ScoringCategoryDetailListComponent;
